export default __webpack_public_path__ + "static/media/ID.bbdc217b.svg";